export function removeFalsyValues(obj) {
  if (!obj) return {};
  return Object.fromEntries(
    Object.entries(obj).filter(([key, value]) => Boolean(value) || value === 0)
  );
}
